import reducer from "./reducers";

import * as questionOperations from "./operations";

export { questionOperations };

export default reducer;